export default "/images/6552530f7cb9f8a253c40c38d1d9690a.avif";